import axios from "axios";
import { toast } from 'react-toastify';
import { addAuthInterceptor } from "../../api/authInterceptor";



const apiGetClient = axios.create({
    baseURL: process.env.REACT_APP_FOUNDATION_API_BASE_URL, // Replace with your API base URL
    headers: {
        "Content-Type": "application/json",
    },
});

addAuthInterceptor(apiGetClient);


export const getAllLanguages = async () => {
  try {
          const response = await apiGetClient.get(`foundation/languages`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
}

export const getAllUserLanguages = async () => {
  try {
          const response = await apiGetClient.get(`foundation/user-languages`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
}

export const getResources = async () => {
  try {
          const response = await apiGetClient.get(`foundation/resources`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
}

export {
    apiGetClient
};